// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { PaginationMeta, PaginationMetaT, verifyPaginationMeta } from "./pagination-meta";
import { ActionBank, ActionBankT, verifyActionBank } from "../archive/action-bank";

/**
 * Paginated response for action banks — the configured buttons on one bank.
 *
 * Added so `/action-banks/by-bank/{id}` can answer in `FlatBuffers` rather than
 * JSON. The row already carries four verdicts a JSON consumer had to be told
 * about separately — `action_scope`, `floor_scope`, `expected_response` and
 * `expected_response_timeout` — and the JSON path has now twice silently
 * dropped one of them between the server deriving it and the client reading
 * it. A typed envelope makes that failure a decode error instead of a field
 * that is quietly always `undefined`.
 *
 * `meta` is carried even though the endpoint is not paged, so the shape
 * matches every sibling in this file and paging can be added without a
 * breaking change.
 */
export class PaginatedActionBanks implements flatbuffers.IUnpackableObject<PaginatedActionBanksT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): PaginatedActionBanks {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsPaginatedActionBanks(
    bb: flatbuffers.ByteBuffer,
    obj?: PaginatedActionBanks,
  ): PaginatedActionBanks {
    return (obj || new PaginatedActionBanks()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsPaginatedActionBanks(
    bb: flatbuffers.ByteBuffer,
    obj?: PaginatedActionBanks,
  ): PaginatedActionBanks {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new PaginatedActionBanks()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  meta(obj?: PaginationMeta): PaginationMeta | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new PaginationMeta()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  data(index: number, obj?: ActionBank): ActionBank | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new ActionBank()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  dataLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startPaginatedActionBanks(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMeta(builder: flatbuffers.Builder, metaOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, metaOffset, 0);
  }

  static addData(builder: flatbuffers.Builder, dataOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, dataOffset, 0);
  }

  static createDataVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startDataVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endPaginatedActionBanks(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createPaginatedActionBanks(
    builder: flatbuffers.Builder,
    metaOffset: flatbuffers.Offset,
    dataOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    PaginatedActionBanks.startPaginatedActionBanks(builder);
    PaginatedActionBanks.addMeta(builder, metaOffset);
    PaginatedActionBanks.addData(builder, dataOffset);
    return PaginatedActionBanks.endPaginatedActionBanks(builder);
  }

  unpack(): PaginatedActionBanksT {
    return new PaginatedActionBanksT(
      this.meta() !== null ? this.meta()!.unpack() : null,
      this.bb!.createObjList<ActionBank, ActionBankT>(this.data.bind(this), this.dataLength()),
    );
  }

  unpackTo(_o: PaginatedActionBanksT): void {
    _o.meta = this.meta() !== null ? this.meta()!.unpack() : null;
    _o.data = this.bb!.createObjList<ActionBank, ActionBankT>(
      this.data.bind(this),
      this.dataLength(),
    );
  }

  unpackFields(...fields: string[]): PaginatedActionBanksT {
    const t = new PaginatedActionBanksT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("meta")) {
      t.meta = this.meta() !== null ? this.meta()!.unpack() : null;
    }
    if (fieldSet.has("data")) {
      t.data = this.bb!.createObjList<ActionBank, ActionBankT>(
        this.data.bind(this),
        this.dataLength(),
      );
    }
    return t;
  }
}

export class PaginatedActionBanksT implements flatbuffers.IGeneratedObject {
  constructor(
    public meta: PaginationMetaT | null = null,
    public data: ActionBankT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const meta = this.meta !== null ? this.meta!.pack(builder) : 0;
    const data = PaginatedActionBanks.createDataVector(
      builder,
      builder.createObjectOffsetList(this.data),
    );

    return PaginatedActionBanks.createPaginatedActionBanks(builder, meta, data);
  }

  clone(): PaginatedActionBanksT {
    const obj = new PaginatedActionBanksT();
    obj.meta = this.meta !== null ? this.meta!.clone() : null;
    obj.data = this.data.map((e) => e.clone());
    return obj;
  }

  equals(other: PaginatedActionBanksT): boolean {
    if (this.meta !== null && other.meta !== null) {
      if (!this.meta!.equals(other.meta!)) return false;
    } else if (this.meta !== other.meta) return false;
    if (this.data.length !== other.data.length) return false;
    for (let i = 0; i < this.data.length; i++) {
      const a = this.data[i];
      const b = other.data[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyPaginatedActionBanks(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyPaginationMeta(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyActionBank);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
